if (typeof requestAnimationFrame !== 'function') {
	window.requestAnimationFrame = function (callback) {
		if (typeof callback === 'function') {
			callback();
		}
	};
}


// WEBPACK FOOTER //
// ./js/vendor/polyfills/polyfill-request-animation-frame.js